import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {esNormativaV2, fusionDeLaEmpresa} from '../../../../utils/normativa.utils'

export default function FilaFusionDTE() {
  const {datosEmisor} = useSelector((state: State) => state.catalogos)

  if (!esNormativaV2(datosEmisor)) return null

  const fusion = fusionDeLaEmpresa(datosEmisor)

  return (
    <tr>
      <td>Fusión:</td>
      <td>{fusion || 'Sin fusión registrada'}</td>
    </tr>
  )
}
